import {Environment, getEnvironment} from "./EnvironmentConfig";
import {checkOrdersV4Flag, FloodGateResponse, isFeatureEnabledForOrg} from "../service/FloodgateService";

let rcpFlag: boolean;
let rcpFlagDev: boolean;

export function isRcpFlagEnabled(): boolean {
    return rcpFlag || getEnvironment() === Environment.LOCAL;
}

export function isRcpFlagDevEnabled(): boolean {
    return rcpFlagDev || getEnvironment() === Environment.LOCAL;
}

let createPaFlag: boolean;
let createPaFlagDev: boolean;

export function isCreatePaFlagEnabled(): boolean {
    return createPaFlag || getEnvironment() === Environment.LOCAL;
}

export function isCreatePaFlagDevEnabled(): boolean {
    return createPaFlagDev || getEnvironment() === Environment.LOCAL;
}


let worldWideFlag: boolean;
let worldWideFlagDev: boolean;
let transferWWFlag: boolean;
let transferWWFlagDev: boolean;
let transferLGAFlag: boolean;
let transferLGAFlagDev: boolean;
let retailFlowFlag: boolean;
let retailFlowFlagDev: boolean;
let linkedMembershipFlag: boolean;
let linkedMembershipFlagDev: boolean;
let allowedActionsFlag: boolean;
let allowedActionsFlagDev: boolean;
let highPenFlag: boolean;
let highPenFlagDev: boolean;
let renewalStatusFlag: boolean;
let renewalStatusFlagDev: boolean;
let hvdFlag: boolean;
let hvdFlagDev: boolean;
let deprecationBannerDisabledFlag: boolean;
let deprecationBannerDisabledFlagDev: boolean;
let flexPromoFlag: boolean;
let flexPromoFlagDev: boolean;
let applicableOnRenewalFlag: boolean;
let applicableOnRenewalFlagDev: boolean;
let flexDiscountsIntroFlag: boolean;
let flexDiscountsIntroFlagDev: boolean;
let flexPromoReusabilityFlag: boolean;
let flexPromoReusabilityFlagDev: boolean;
let odDiscountsFlag: boolean;
let odDiscountsFlagDev: boolean;
let overlayLeadsFlag: boolean;
let overlayLeadsFlagDev: boolean;

export function isWorldWideFlagEnabled(): boolean {
    return worldWideFlag || getEnvironment() === Environment.LOCAL;
}

export function isWorldWideFlagDevEnabled(): boolean {
    return worldWideFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isTransferWWFlagEnabled(): boolean {
    return transferWWFlag || getEnvironment() === Environment.LOCAL;
}

export function isTransferWWFlagDevEnabled(): boolean {
    return transferWWFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isTransferLGAFlagEnabled(): boolean {
    return transferLGAFlag || getEnvironment() === Environment.LOCAL;
}

export function isTransferLGAFlagDevEnabled(): boolean {
    return transferLGAFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isRetailFlowFlagEnabled(): boolean {
    return retailFlowFlag || getEnvironment() === Environment.LOCAL;
}

export function isRetailFlowFlagDevEnabled(): boolean {
    return retailFlowFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isLMflagEnabled(): boolean {
    return linkedMembershipFlag || getEnvironment() === Environment.LOCAL;
}

export function isLMflagDevEnabled(): boolean {
    return linkedMembershipFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isAllowedActionsFlagEnabled(): boolean {
    return allowedActionsFlag || getEnvironment() === Environment.LOCAL;
}

export function isAllowedActionsFlagDevEnabled(): boolean {
    return allowedActionsFlagDev || getEnvironment() === Environment.LOCAL;
}    
    
export function isHighPenFlagEnabled(): boolean {
    return highPenFlag || getEnvironment() === Environment.LOCAL;
}

export function isHighPenFlagDevEnabled(): boolean {
    return highPenFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isRenewalStatusFlagEnabled(): boolean {
    return renewalStatusFlag || getEnvironment() === Environment.LOCAL;
}

export function isRenewalStatusFlagDevEnabled(): boolean {
    return renewalStatusFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isHVDFlagEnabled(): boolean {
    return hvdFlag || getEnvironment() === Environment.LOCAL;
}

export function isHVDFlagDevEnabled(): boolean {
    return hvdFlagDev || getEnvironment() === Environment.LOCAL;
}

export async function isDeprecationBannerFlagEnabled(): Promise<boolean> {
    const isOrdersV4Dist = await checkOrdersV4Flag();
    return !isOrdersV4Dist || getEnvironment() === Environment.LOCAL;
}

export function isDeprecationBannerFlagDevEnabled(): boolean {
    return !deprecationBannerDisabledFlagDev ;
}

export function isFlexPromoFlagEnabled(): boolean {
    return flexPromoFlag || getEnvironment() === Environment.LOCAL;
}

export function isFlexPromoFlagDevEnabled(): boolean {
    return flexPromoFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isFlexPromoReusabilityFlagEnabled(): boolean {
    return flexPromoReusabilityFlag || getEnvironment() === Environment.LOCAL;
}

export function isFlexPromoReusabilityFlagDevEnabled(): boolean {
    return flexPromoReusabilityFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isOdDiscountsFlagEnabled(): boolean {
    return odDiscountsFlag || getEnvironment() === Environment.LOCAL;
}

export function isOdDiscountsFlagDevEnabled(): boolean {
    return odDiscountsFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isApplicableOnRenewalFlagEnabled(): boolean {
    return applicableOnRenewalFlag || getEnvironment() === Environment.LOCAL;
}

export function isApplicableOnRenewalFlagDevEnabled(): boolean {
    return applicableOnRenewalFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isFlexDiscountsIntroFlagEnabled(): boolean {
    return flexDiscountsIntroFlag || getEnvironment() === Environment.LOCAL;
}

export function isFlexDiscountsIntroFlagDevEnabled(): boolean {
    return flexDiscountsIntroFlagDev || getEnvironment() === Environment.LOCAL;
}

export function isOverlayLeadsFlagEnabled(): boolean {
    return overlayLeadsFlag;
}

export function isOverlayLeadsFlagDevEnabled(): boolean {
    return overlayLeadsFlagDev;
}

export const isFlagEnabled = (response : FloodGateResponse) => {
    rcpFlag = isFeatureEnabledForOrg('sandbox_ui_rcp_changes_enabled', response);
    rcpFlagDev = isFeatureEnabledForOrg('sandbox_ui_rcp_changes_enabled_dev', response);
    worldWideFlag = isFeatureEnabledForOrg('sandbox_ui_worldwide_changes_enabled', response);
    worldWideFlagDev = isFeatureEnabledForOrg('sandbox_ui_worldwide_changes_enabled_dev', response);
    transferWWFlag = isFeatureEnabledForOrg('sandbox_ui_transfer_ww_changes_enabled', response);
    transferWWFlagDev = isFeatureEnabledForOrg('sandbox_ui_transfer_ww_changes_enabled_dev', response);
    transferLGAFlag = isFeatureEnabledForOrg('sandbox_ui_transfer_lga_changes_enabled', response);
    transferLGAFlagDev = isFeatureEnabledForOrg('sandbox_ui_transfer_lga_changes_enabled_dev', response);
    retailFlowFlag = isFeatureEnabledForOrg('sandbox_ui_retail_flow_enabled_flow', response);
    retailFlowFlagDev = isFeatureEnabledForOrg('sandbox_ui_retail_flow_enabled_dev', response);
    createPaFlag = isFeatureEnabledForOrg('sandbox_ui_create_pa_enabled', response);
    createPaFlagDev = isFeatureEnabledForOrg('sandbox_ui_create_pa_enabled_dev', response);
    linkedMembershipFlag = isFeatureEnabledForOrg('sandbox_ui_lm_changes_enabled', response);
    linkedMembershipFlagDev = isFeatureEnabledForOrg('sandbox_ui_lm_changes_enabled_dev', response);
    allowedActionsFlag = isFeatureEnabledForOrg('sandbox_ui_allowed_actions_enabled', response);
    allowedActionsFlagDev = isFeatureEnabledForOrg('sandbox_ui_allowed_actions_enabled_dev', response);
    highPenFlag = isFeatureEnabledForOrg('sandbox_ui_high_pen_enabled', response);
    highPenFlagDev = isFeatureEnabledForOrg('sandbox_ui_high_pen_enabled_dev', response);
    renewalStatusFlag = isFeatureEnabledForOrg('sandbox_ui_renewal_status_enabled', response);
    renewalStatusFlagDev = isFeatureEnabledForOrg('sandbox_ui_renewal_status_enabled_dev', response);
    hvdFlag = isFeatureEnabledForOrg('sandbox_ui_hvd_enabled', response);
    hvdFlagDev = isFeatureEnabledForOrg('sandbox_ui_hvd_enabled_dev', response);
    deprecationBannerDisabledFlagDev = isFeatureEnabledForOrg('use_orders_v4_dev', response);
    flexPromoFlag = isFeatureEnabledForOrg('sandbox_ui_flex_promo_enabled', response);
    flexPromoFlagDev = isFeatureEnabledForOrg('sandbox_ui_flex_promo_enabled_dev', response);
    applicableOnRenewalFlag = isFeatureEnabledForOrg('sandbox_ui_applicable_on_renewal_enabled', response);
    applicableOnRenewalFlagDev = isFeatureEnabledForOrg('sandbox_ui_applicable_on_renewal_enabled_dev', response);
    flexDiscountsIntroFlagDev = isFeatureEnabledForOrg('sandbox_ui_flex_discounts_intro_enabled_dev', response);
    flexDiscountsIntroFlag = isFeatureEnabledForOrg('sandbox_ui_flex_discounts_intro_enabled', response);
    flexPromoReusabilityFlag = isFeatureEnabledForOrg('sandbox_ui_flex_promo_reusability_enabled', response);
    flexPromoReusabilityFlagDev = isFeatureEnabledForOrg('sandbox_ui_flex_promo_reusability_enabled_dev', response);
    odDiscountsFlag = isFeatureEnabledForOrg('sandbox_ui_od_discounts_enabled', response);
    odDiscountsFlagDev = isFeatureEnabledForOrg('sandbox_ui_od_discounts_dev_enabled', response);
    overlayLeadsFlag = isFeatureEnabledForOrg('sandbox_ui_overlay_leads_enabled', response);
    overlayLeadsFlagDev = isFeatureEnabledForOrg('sandbox_ui_overlay_leads_enabled_dev', response);
}
